export const SX_STYLES = {
    contentContainer: {
        minHeight: '100vh',
    },
}